import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyAhQFgqLjIPrP3n4cHMidMzhtyoFfwNrvM",
    authDomain: "game-master-bf084.firebaseapp.com",
    projectId: "game-master-bf084",
    storageBucket: "game-master-bf084.appspot.com",
    messagingSenderId: "350630984936",
    appId: "1:350630984936:web:fbdc7293af5dda7f191d5d"
  };

var firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.firestore();
export const storage = firebaseApp.storage().ref();

const { TimeStamp, GeoPoint } = firebase.firestore
export { TimeStamp, GeoPoint }